import awsdk from 'awsdk';

// Unpublished
// Unscheduled
// Scheduled
// Parked
// ConsumerCanceled
// Declined
// ProviderResponseTimeout
// PreVisitScreening
// InProgress
// PostVisitConversation
// Bailed
// ProviderDisconnected
// ProviderWrapup
// ConsultingProviderWrappedUp
// Completed
// Error
// CollapseDeleted
// Deleted
// ProviderCanceled
// ConsumerDisconnected
// Expired

export const Disposition = awsdk.AWSDKDisposition;
export type Disposition = typeof Disposition;
